function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { List, Typography, Alert, Image, Divider } from 'antd';
import { BoxFill } from "react-bootstrap-icons";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Receipt = function Receipt(_ref) {
  var order = _ref.order;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    totalAmount = _useState2[0],
    setTotalAmount = _useState2[1];
  return /*#__PURE__*/_jsxs("div", {
    style: {
      textAlign: "center"
    },
    children: [/*#__PURE__*/_jsx(Image, {
      src: "/drawables/alo.png",
      width: "150px",
      preview: false
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h4", {
      children: /*#__PURE__*/_jsxs("b", {
        children: ["R\xE9\xE7u de paiement N\xBA ", order.id]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h6", {
      children: [/*#__PURE__*/_jsx("b", {
        children: "Client : "
      }), " ", order.customer && order.customer.mobile]
    }), /*#__PURE__*/_jsxs("h6", {
      children: [/*#__PURE__*/_jsx("b", {
        children: "Date : "
      }), " ", /*#__PURE__*/_jsx(Moment, {
        date: order.created_at,
        format: "DD/MM/YYYYY"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        marginTop: "14px",
        padding: "6px",
        border: "1px dashed #509750",
        borderRadius: "8px"
      },
      children: [/*#__PURE__*/_jsx("h6", {
        children: /*#__PURE__*/_jsx("b", {
          children: "R\xE9sum\xE9 commande"
        })
      }), /*#__PURE__*/_jsx(List, {
        dataSource: order.purchase_order_items,
        itemLayout: "vertical",
        size: "small",
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(List.Item.Meta, {
              avatar: /*#__PURE__*/_jsx(BoxFill, {
                size: 15
              }),
              title: /*#__PURE__*/_jsxs("span", {
                style: {
                  fontSize: "14px"
                },
                children: [item.label, " | Qte: ", item.quantity, ", P.U: ", item.price.toLocaleString("Fr")]
              })
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "TOTAL GnF: "
        }), order.total_amount.toLocaleString("Fr")]
      })]
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default Receipt;